import Content from "./index";

export default {
  path: "configuration",
  name: "Configuration Control",
  component: Content

};
